import newsApi from '../../apis/news.api';
import activityApi from '../../apis/activity.api';
const newsListPromises = {};
const activityListPromises = {};
export default {
  state: {
    newsInfo: {
      type: 0,
      currentActivity: null,
      currentPromotion: null
    }
  },
  mutations: {
    setPromotion (state, promotion) {
      state.newsInfo = {
        type: 0,
        currentActivity: null,
        currentPromotion: promotion
      };
    },
    setActivity (state, activity) {
      state.newsInfo = {
        type: 1,
        currentActivity: activity,
        currentPromotion: null
      };
    }
  },
  getters: {
    newsInfo: state => state.newsInfo
  },
  actions: {
    loadActivityInfo ({ commit }, id) {
      if (!activityListPromises[id]) {
        activityListPromises[id] = activityApi.getActivityDetail({ activityId: id });
      }
      return activityListPromises[id]
        .then(function (activity) {
          commit('setActivity', activity);
          return Promise.resolve(activity);
        });
    },
    loadPromotionInfo ({ commit }, { id, openDetail = true }) {
      if (!newsListPromises[id]) {
        newsListPromises[id] = newsApi.loadPromotionInfo(id);
      }
      return newsListPromises[id].then(function (promotion) {
        if (openDetail) {
          commit('setPromotion', promotion);
        }
        return Promise.resolve(promotion);
      });
    }
  },
  namespaced: true
};
